import * as React from "react";
import { createSvgIcon } from "@material-ui/core/utils";
export var iconPath = (React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.233 4H4.764C3.24 4 2 5.228 2 6.74V20l4.558-2.964h12.678c1.526 0 2.764-1.228 2.764-2.741V6.74C22 5.228 20.762 4 19.233 4ZM11 6h2v6h-2V6Zm2 7h-2v2h2v-2Z" }));
export default createSvgIcon(iconPath, "PlayerReports");
//# sourceMappingURL=PlayerReportsIcon.js.map